import { getURLProps } from './setPagesUrl';

type setQueryParamsReturnType = Record<string, string>;

export const setQueryParams = (
  paramsArray: string[],
  location: any,
  getMore?: boolean
): setQueryParamsReturnType => {
  const paramsObj = {};
  paramsArray.forEach(item => {
    const param = getURLProps({ pathname: location.pathname })[item];
    if (item === 'page' && getMore) {
      paramsObj[item] = +param + 1;
    } else if (param !== '0' && param !== '' && item === 'search') {
      paramsObj[item] = param;
    } else if (param !== '0' && param !== '') {
      paramsObj[item] = +param;
    }
  });
  return paramsObj;
};
